import React, { type ReactNode } from 'react';

import classNames from 'classnames';

export interface Detail {
  title: string;
  detail: string | number | ReactNode;
}
export interface ItemListProps {
  details: Detail[];
  className?: string;
  titleClassName?: string;
  detailsClassName?: string;
}
export default function ItemList({
  details,
  className,
  titleClassName,
  detailsClassName,
}: ItemListProps) {
  return details.map(({ title, detail }, index) => {
    return (
      <div
        className={classNames(
          'flex h-12 justify-between rounded-lg bg-silver-100 p-2 text-xs text-secondary-default lg:w-full lg:bg-coconut-900',
          className
        )}
        key={index}
      >
        <span
          className={classNames(
            'bold my-auto text-sm text-secondary-300',
            titleClassName
          )}
        >
          {title}
        </span>
        <div className={classNames('my-auto', detailsClassName)}>{detail}</div>
      </div>
    );
  });
}
